import EmberObject from "@ember/object"
import { inject as service } from "@ember/service"
import ENV from "../config/environment"

export default class TrialAdapter extends EmberObject {
  @service ajax

  find(ids = []) {
    return this.ajax.requestFromAdapter(ENV.API_ROOT + "/trials/" + ids.join(","))
  }
}
